import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useQuery } from '@tanstack/react-query';
import { Integration } from '@/types/models/Integration';

type Filters =
  | {
      restaurant_id?: number | null;
      id?: number | null;
    }
  | undefined;
const useIntegrations = (enabled: boolean = true, filters: Filters = undefined) => {
  const client = supabaseClient;
  const queryKey = ['integrations', filters?.restaurant_id, filters?.id];

  const queryFn = async () => {
    return getIntegrations(client, filters);
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export default useIntegrations;

function getIntegrations(client: SupabaseClient, filters: Filters): Integration[] {
  let clientWithFilters = client
    .from('integrations')
    .select(
      `
        id,
        restaurant_id(id, name),
        platform_name,
        api_key,
        secret_token,
        venue_group_id,
        venue_id,
        created_at
      `
    )
    .order('created_at', { ascending: false });

  if (filters?.restaurant_id) {
    clientWithFilters = clientWithFilters.eq('restaurant_id', filters.restaurant_id);
  }

  if (filters?.id) {
    clientWithFilters = clientWithFilters.eq('id', filters.id);
  }

  return clientWithFilters.then((result: any) => result.data) as unknown as Integration[];
}
